import { IconShoppingCartSimple, Text } from '@vtex/admin-ui'
import { FormattedMessage } from 'react-intl'
import { MaxItemPerCart } from 'typings'
import { Tag } from '../../../Tag'
import { RuleContent, RuleDescription, RuleIcon } from '../../RuleStack'
import { messages } from '../messages'
import { styles } from '../styles'

export function MaxItemsPerCartView(props: { restriction: MaxItemPerCart }) {
  const { restriction } = props

  return (
    <>
      <RuleIcon>
        <IconShoppingCartSimple />
      </RuleIcon>

      <RuleDescription>
        <FormattedMessage
          {...messages.view.maxItemsPerCart}
          values={{
            b: (content) => <Text variant="body">{content}</Text>,
          }}
        />
      </RuleDescription>

      <RuleContent>
        <div className={styles.detailedView}>
          <Tag>
            <FormattedMessage
              {...messages.view.items}
              values={{ value: restriction.value }}
            />
          </Tag>
          <Text variant="detail" tone="secondary" hidden={!restriction.applyTo}>
            <FormattedMessage
              {...messages.view.AppliedTo}
              values={{
                value: restriction.value,
                applyTo: restriction.applyTo,
              }}
            />
          </Text>
        </div>
      </RuleContent>
    </>
  )
}
